/* unplugin-vue-components disabled */import script from "./topic-dialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./topic-dialog.vue?vue&type=script&setup=true&lang=ts"

import "./topic-dialog.vue?vue&type=style&index=0&id=8cc88476&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8cc88476"]])

export default __exports__